import * as React from 'react';

interface DownloadButtonProps {
  children: React.ReactNode;
  className?: string | null;
  disabled?: boolean;
  title?: string;
  url: string | null;
}

export const DownloadButton = (props: DownloadButtonProps) => {
  if (!props.url) {
    return null;
  }
  if (props.disabled) {
    return (
      <div
        className={props.className ?? undefined}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          // prevent the click from doing anything
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {props.children}
      </div>
    );
  }
  return (
    <a
      download
      href={props.url}
      title={props.title ?? 'Download'}
      className={props.className ?? undefined}
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        // prevent the click from doing anything other than the download
        e.stopPropagation();
      }}
    >
      {props.children}
    </a>
  );
};
